<template>
  <div class="p-4">
    <div class="cards-grid mb-5" v-if="selectionModules.length">
      <CardModule
        v-for="(module, index) in selectionModules"
        :key="index"
        :module="module"
        @add="addSelectedModule"
        @remove="removeSelectedModule"
      />
      <v-skeleton-loader
        v-for="i in (selectionModules.length ? 0 : 6)"
        :key="i"
        type="table-heading, list-item-one-line, image"
      />
    </div>

    <div class="d-flex flex-column flex-md-row justify-content-md-center align-items-md-center p-4">
      <v-btn
        outlined
        class="mr-1 border-nitro text-nitro"
        @click="onCancel"
      >
        voltar
      </v-btn>
      <v-btn
        color="nitro"
        :disabled="!selectionModules.length || selectedSelectionModules.length != selectedCycle.modules_quantity"
        class="text-white"
        @click="showModal = true"
      >
        Continuar conteúdo ({{ selectedSelectionModules.length }} / {{ selectedCycle.modules_quantity }})
      </v-btn>
    </div>
    <v-dialog
      v-if="selectedSelectionModules.length"
      v-model="showModal"
      width="600"
      persistent
      :overlay-opacity="DEFAULT_MODAL_OPACITY"
      :overlay-color="DEFAULT_MODAL_OVERLAY_COLOR"
    >
      <ConfirmSelection
        @onConfirm.once="onConfirm"
        @onClose="showModal = false"
      />
    </v-dialog>
    <v-overlay
      :value="isLoadingModules"
      class="text-center"
    >
      <InsideLoader />
      <p class="mt-2 text-center">
        {{ loading_modules_message }}
      </p>
    </v-overlay>
    <v-overlay
      :value="loadedSelectionModules && !hasSelectionModules"
      :z-index="1"
      :opacity="DEFAULT_MODAL_OPACITY"
    >
      <RecommendedModulesWarning />
    </v-overlay>
  </div>
</template>
<script>

import CardModule from '@/student/pages/module/components/CardModule'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { studyNowRouteName, homeRouteName } from '@/student/constants/routes'
import {DEFAULT_MODAL_OPACITY, DEFAULT_MODAL_OVERLAY_COLOR} from "@/student/constants/general.js"
import ConfirmSelection from '@/student/pages/module/components/ConfirmSelection'
import RecommendedModulesWarning from "./RecommendedModulesWarning.vue";
import InsideLoader from '@/common/InsideLoader'

export default {
  components: {
    CardModule,
    InsideLoader,
    ConfirmSelection,
    RecommendedModulesWarning,
},
  data() {
    return {
      showModal: false,
      homeRouteName,
      DEFAULT_MODAL_OPACITY,
      DEFAULT_MODAL_OVERLAY_COLOR,
      studyNowRouteName,
    }
  },
  computed: {
    ...mapGetters([
      'current_cycle',
      'hasSelectionModules',
      'selectedCycle',
      'selectionModules',
      'selectedSelectionModules',
      'disableModuleSelection',
      'loadedSelectionModules',
      'loading_modules_message',
      'isLoadingModules',
      'synced_subtopics',
      'trails',
      'selectedBlocks',
      'selectedTrailId',
      'authUser',
    ]),
  },
  mounted(){
    this.loadData();
  },
  methods: {
    ...mapMutations(['SET_CYCLE','SET_SELECTION_MODULES']),
    ...mapActions(['getSelectionModules', 'setupModules', 'getCycles', 'syncSubtopicsWeights','getTrails',]),
    async loadData(){
      const action = this.synced_subtopics ? this.getSelectionModules() : this.syncSubtopicsWeights().then(()=>this.getSelectionModules())
      await action
    },
    onConfirm() {
      this.isSettingModules = true
      this.showModal = false
      this.setupModules({
        modules: this.selectedSelectionModules.map(m => m.id),
        cycle_config_id: this.selectedCycle.id,
        trail_id: this.selectedTrailId ? this.selectedTrailId : this.authUser.current_trail.id,
        blocks: this.selectedBlocks.map(b => b.id)
      })
      .then(() => {
        this.getCycles()
        .then(() => {
          this.$router.push({name: studyNowRouteName})
        })
      })
    },
    onCancel(){
      this.$emit('onCancel')
    },
    updateSelection(module, value){
      this.SET_SELECTION_MODULES([...this.selectionModules.map( m => {
        if(m.id == module.id) {
          m.selected = value
        }
        return m
      } )])
    },
    addSelectedModule(module) {
      if(!this.disableModuleSelection)
        this.updateSelection(module, true)
    },
    removeSelectedModule(module) {
      this.updateSelection(module, false)
    }
  }
}
</script>
<style scoped>
.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(290px, 1fr));
  gap: 1.2em;
}
</style>

